<template>
  <div>
    <v-tabs v-model="tabValue">
      <v-tab href="#tab-1">單工資更新</v-tab>
      <v-tab href="#tab-2">批次更新</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <update-one-customer-repair class="ma-5" :fatherTabValue="tabValue" />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <update-many-customer-repair class="ma-5" :fatherTabValue="tabValue" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import UpdateOneCustomerRepair from '@/components/UpdateCustomerRepair/UpdateOneCustomerRepair.vue'
import UpdateManyCustomerRepair from '@/components/UpdateCustomerRepair/UpdateManyCustomerRepair.vue'
export default {
  components: { UpdateOneCustomerRepair, UpdateManyCustomerRepair },
  name: 'UpdateCustomerRepair',
  data () {
    return {
      tabValue: 'tab-1'
    }
  }
}
</script>
